import React, { useEffect, useState } from "react";
import moment from "moment";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { useAppContext } from "store/context";
import { useCustomClaims, useBaristaStation } from "hooks";
import Splash from "components/Splash";
import LoadingSpinner from "components/LoadingSpinner";
import Orders from "./components/Orders";

const OrdersContainer = ({ authed }) => {
  const { firebase, user } = useAppContext();
  const {
    claims: { merchant_id },
  } = useCustomClaims(user);
  const {
    station: { id: device_id },
  } = useBaristaStation();
  const refreshOrders = firebase.functions().httpsCallable("refreshOrders");
  const sendOrderComplete = firebase.functions().httpsCallable("sendOrderComplete");
  const setupOrders = firebase.functions().httpsCallable("demoSetup");
  const [demoSetup, setDemoSetup] = useState(false);

  useEffect(() => {
    const getDemoOrders = async () => {
      if (authed && process.env.REACT_APP_DEMO_MODE) {
        const { data: success } = await setupOrders();
        setDemoSetup(success);
      } else {
        setDemoSetup(true);
      }
    };
    getDemoOrders();
    // eslint-disable-next-line
  }, [authed]);

  const [orders, loading] = useCollectionData(
    firebase
      .firestore()
      .collection(`orders_${merchant_id}`)
      .where("created_at", ">=", moment().startOf("day").toISOString())
      .where("created_at", "<=", moment().endOf("day").toISOString())
  );

  if (!authed) {
    return <Splash />;
  }

  if (loading || !orders || !demoSetup) {
    return <LoadingSpinner />;
  }

  const handleRefresh = async () => {
    try {
      await refreshOrders();
    } catch (e) {
      console.error(e);
    }
  };

  const handleDone = async (order_id, created_at, pickup_at) => {
    try {
      const completed_at = moment().utc().toISOString();
      await firebase
        .firestore()
        .collection(`orders_${merchant_id}`)
        .doc(order_id)
        .update({
          completed_at,
          average_time: moment(completed_at).diff(pickup_at || created_at),
        });

      await sendOrderComplete({ order_id });
    } catch (error) {
      console.error(`Error updating doc: ${error.message}`);
    }
  };

  return <Orders device_id={device_id} orders={orders} onRefresh={handleRefresh} onDone={handleDone} />;
};

export default OrdersContainer;
